import { useMutation, useQueryClient } from "@tanstack/react-query";
import { partnerApiService } from "@/services/partner-api.service";
import type { ProvisionTeamInput } from "@/types/partner.types";

export const useCreateClient = () => {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: (input: ProvisionTeamInput) =>
			partnerApiService.provisionTeam(input),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ["partner", "clients"] });
			queryClient.invalidateQueries({ queryKey: ["partner", "overview"] });
		},
	});
};
